<div class="content">
    <div class="selectors">
        <igx-date-picker type="border" (valueChange)="dateChange($event)">
            <label igxLabel>Избери дата</label>
        </igx-date-picker>
        <igx-combo #busesCombo type="border" [data]="buses.array()" [disabled]="!date" valueKey="id"
            displayKey="registrationNumber" (selectionChanging)="busesChange($event)">
            <label igxLabel>Избери бусове</label>
            <ng-template igxComboItem let-display>
                <div [style.background]="display?.color" class="region">
                    {{ display.registration_number }} - max
                    {{ display.capacity }}
                </div>
            </ng-template>
        </igx-combo>
        <button [disabled]="!canSave()" igxButton="contained" (click)="save()">Запази</button>
    </div>
    @if (date != null) {
        <div class="selectors">
            <div style="width: 50%;">
                <h5 class="header">{{kids.size}} {{kids.size == 1 ? "дете разпределено" : "деца разпределени"}} по спирки</h5>
                <div class="cards">
                    @for (stop of stops; track stop.id) {
                        <igx-card class="card" elevated>
                            <igx-card-header>
                                <h5 igxCardHeaderSubtitle>{{stop.name}} - {{stop.description}}</h5>
                            </igx-card-header>
                            <igx-card-content>
                                <igx-chips-area>
                                    @for (kid of kidOnStop(stop); track kid.id) {
                                        <igx-chip [id]="kid.id" [draggable]="true">{{kid.name}}</igx-chip>
                                    }
                                </igx-chips-area>
                            </igx-card-content>
                            <igx-card-actions>
                                <igx-select #select type="border" (selectionChanging)="moveAllKidsToBus($event, stop, select)">
                                    <label igxLabel>Избери бус</label>
                                    @for (bus of selectedBuses(); track bus.id) {
                                        <igx-select-item [value]="bus.id">
                                            {{bus.registrationNumber}}
                                        </igx-select-item>
                                    }
                                </igx-select>
                            </igx-card-actions>
                        </igx-card>
                    }
                </div>
            </div>
            <div style="width: 50%;">
                <h5 class="header">Разпределение по бусове</h5>
                <div class="cards">
                    @for (group of groups.values(); track group.bus) {
                        <igx-card class="card" [style.border]="'3px solid ' + buses.get(group.bus).color" elevated>
                            <igx-card-header>
                                <h3 igxCardHeaderTitle>{{ buses.get(group.bus).registrationNumber }}</h3>
                                <h5 igxCardHeaderSubtitle>{{ occupiedSeatsOnBus(group) }} / {{ busCapacity(group.bus) }}</h5>
                                <igx-select type="border" (selectionChanging)="changeDriver($event, group)" [value]="group.driver">
                                    @for (driver of drivers; track driver.id) {
                                        <igx-select-item [value]="driver.id">
                                            {{ driver.firstName }} {{ driver.lastName }}
                                        </igx-select-item>
                                    }
                                </igx-select>
                            </igx-card-header>
                            <igx-chips-area igxDrop (dropped)="addToBus($event, group)">
                                <igx-card-content [style.background]="'hsla(var(--igx-grays-200))'">
                                    @for (stop of stops; track stop.id) {
                                        @if (kidOnBus(group, stop).size > 0) {
                                            <p [style.margin]="0">{{ stop.name }}</p>
                                        }
                                        @for (kid of kidOnBus(group, stop); track kid.id) {
                                            <igx-chip
                                                [id]="kid.id!" [removable]="true" [draggable]="true"
                                                (remove)="removeKidFromBus(kid, group)"
                                            >
                                                {{ kid.name }}
                                            </igx-chip>
                                        }
                                    }
                                </igx-card-content>
                            </igx-chips-area>
                            @if (occupiedSeatsOnBus(group) > busCapacity(group.bus)) {
                                <igx-hint [style.color]="'red'">ПРЕТОВАРВАНЕ!!!</igx-hint>
                            }
                        </igx-card>
                    }
                </div>
            </div>
        </div>
    }
</div>